import { all } from 'redux-saga/effects';
import { driverConfigurationsWatcherSaga } from '../driver-configurations/saga/driverConfigurationsWatcherSaga';
import { driverMarginWatcherSaga } from '../driver-margins/saga/driverMarginWatcherSaga';

export function* packagingDriverWatcherSaga() {
  yield all([driverConfigurationsWatcherSaga(), driverMarginWatcherSaga()]);
}
